import React, { Component } from "react";
import WmsModel from "../../../components/WmsModel/WmsModel.jsx";
import WmsCollapse from "../../../components/WmsCollapse/WmsCollapse.jsx";
import WmsContainer from '../../../components/WmsContainer/WmsContainer.jsx';
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import WmsInput from "../../../components/WmsInput/WmsInput.jsx";
import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import WmsRadio from '../../../components/WmsRadio/WmsRadio.tsx';
import * as GlobalService from '../../../global_services';
import './auto-rate-shopping-rule-model.scss';

export class AutoRateShoppingRuleModel extends Component {

    constructor(props) {
        super(props);
        this.translate = window.translate;
        this.rights = GlobalService.GetRights();

        this.rateShoppingLogics = [
            { text: "Select One...", value: "" },
            { text: "Overnight - Cheapest", value: "Overnight" },
            { text: "2nd Day - Cheapest", value: "TwoDay" },
            { text: "3rd Day - Cheapest", value: "ThreeDay" },
            { text: "4th Day - Cheapest", value: "FourDay" },
            { text: "5th Day - Cheapest", value: "FiveDay" },
            { text: "Cheapest", value: "Cheapest" },
            { text: "Cheapest - Independent of Delivery Date", value: "CheapestDateIndependent" }
        ];

        this.state = {
            autoRateShoppingMapping: "",
            autoRateShoppingLogic: "",
            autoRateShoppingMarkup: "",
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpenAddAutoRateShoppingRuleModel && this.props.isOpenAddAutoRateShoppingRuleModel) {
            this.setState({
                autoRateShoppingMapping: "",
                autoRateShoppingLogic: "",
                autoRateShoppingMarkup: "",
            });
        }
    }

    isMarkupSelected = (markup) => markup === true || markup === false;

    isButtonDisabled = () => {
        const mapping = (this.state.autoRateShoppingMapping || "").trim();
        const logic = (this.state.autoRateShoppingLogic || "").trim();
        return !mapping || !logic || !this.isMarkupSelected(this.state.autoRateShoppingMarkup);
    };

    handleMappingChange = (event) => {
        const value = event?.target?.value || "";
        this.setState({ autoRateShoppingMapping: value }, () => {
            this.props.handleSettingsChange({
                target: {
                    type: "text",
                    name: "AutoRateShoppingMapping",
                    value,
                },
            });
        });
    };

    handleLogicChange = (event) => {
        const value = event?.target?.value || "";
        this.setState({ autoRateShoppingLogic: value }, () => {
            this.props.handleSettingsChange({
                target: {
                    type: "select-one",
                    name: "AutoRateShoppingLogic",
                    value,
                },
            });
        });
    };

    handleMarkupChange = (event) => {
        const eventName = event?.target?.name;
        const markup =
            eventName === "AutoRateShoppingRateAmountMarkup"
                ? true
                : eventName === "AutoRateShoppingRateMarkup"
                    ? false
                    : "";
        this.setState({ autoRateShoppingMarkup: markup }, () => {
            this.props.handleSettingsChange(event);
        });
    };

    render() {
        return (
            <WmsModel
                id={'autoRateShoppingRuleModel'}
                title={this.translate('Label_Add_Auto_Rate_Shopping_Rule')}
                width={800}
                height={750}
                class='auto-rate-shopping-rule-wrapper'
                onCloseFunc={this.props.closeAddAutoRateShoppingRuleModel}
                isOpen={this.props.isOpenAddAutoRateShoppingRuleModel}
                customClass='wms-model-new-ui-wrapper'>

                <div className="model-content-wrapper">
                    <WmsCollapse
                        id={'autoRateShoppingRuleOptions'}
                        headerLabel={this.translate('Label_Options')}
                        showCollapseText={false}
                        showCollapseIcon={false}>
                        <div className="wms-auto-rate-shopping-fields-wrapper">
                            <WmsInput
                                id='AutoRateShoppingMapping'
                                inputName='AutoRateShoppingMapping'
                                wmsSelector={this.props.selector + 'AutoRateShoppingMapping'}
                                onChangeFunc={this.handleMappingChange}
                                label={this.translate('Label_Ship_Service_Keyword')}
                                value={this.state.autoRateShoppingMapping}
                                extraWrapperClass="ship-service-keyword-wrapper"
                                required={true}
                            />

                            <WmsDropdown
                                id='AutoRateShoppingLogic'
                                name='AutoRateShoppingLogic'
                                wmsSelector={this.props.selector + 'AutoRateShoppingLogic'}
                                onChangeFunc={this.handleLogicChange}
                                label={this.translate("Label_Rate_Type")}
                                options={this.rateShoppingLogics}
                                valueField="value"
                                textField="text"
                                parentClassName="form_group"
                                value={this.state.autoRateShoppingLogic}
                                extraWrapperClass="ship-rate-type-wrapper"
                                required={true}
                            />
                        </div>
                        <WmsContainer title={this.translate('Label_Auto_Rate_Shopping_Based_On')}>
                            <div className="wms-auto-rate-shopping-radio-wrapper">
                                <WmsRadio
                                    id={'AutoRateShoppingRateMarkup'}
                                    name={'AutoRateShoppingRateMarkup'}
                                    label={this.translate("Label_Rate")}
                                    wmsSelector={this.props.selector + 'rateMarkup'}
                                    onChangeFunc={this.handleMarkupChange}
                                    checked={this.state.autoRateShoppingMarkup === false}
                                />
                                <WmsRadio
                                    id={'AutoRateShoppingRateAmountMarkup'}
                                    name={'AutoRateShoppingRateAmountMarkup'}
                                    label={this.translate("Label_Rate_Amount_Plus_Markup")}
                                    wmsSelector={this.props.selector + 'rateAmountMarkup'}
                                    onChangeFunc={this.handleMarkupChange}
                                    checked={this.state.autoRateShoppingMarkup === true}
                                />
                            </div>
                        </WmsContainer>
                    </WmsCollapse>
                </div>

                <div className="footer-btn-holder">
                    <WmsButton
                        label={this.translate('Label_Cancel')}
                        wmsSelector={this.props.selector + "cancelLogic"}
                        onClickFunc={this.props.closeAddAutoRateShoppingRuleModel}
                        icon="fa-ban"
                        buttonType="orange"
                    />
                    <WmsButton
                        label={this.translate('Label_Save')}
                        wmsSelector={this.props.selector + "addLogic"}
                        onClickFunc={this.props.eventClickAddLogic}
                        icon="fa-floppy-o"
                        buttonType="green"
                        disabled={this.isButtonDisabled()}
                    />
                </div>
            </WmsModel>
        );
    }
}
